
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[code]",
      function () {
        return require("private-next-pages/brands/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[code]"])
      });
    }
  